import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import Index from './Index.vue';
import Show from './Show.vue';

const meta = {
  permissions: ['administrator', 'agent', 'contact_manage'],
  featureFlag: FEATURE_FLAGS.CUSTOMER_REFERRALS,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/customers'),
    name: 'customers_index',
    component: Index,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/customers/:customerId'),
    name: 'customers_show',
    component: Show,
    meta,
  },
];
